class StekViewController {
	constructor(skContext, listener) {
		this.skContext = skContext;
		this.dragInfo = {
			active: false,
			prevX: 0,
			prevY: 0,
			pointerId: -1
		};

		this.pitchRange = {
			min: -1.2,
			max: 0
		};

		this.listener = listener;
	}

	onPointerDown(e, eventOwnerElement) {
		const ne = e.nativeEvent;
		if (ne && eventOwnerElement) {
			eventOwnerElement.setPointerCapture?.(ne.pointerId);

			const d = this.dragInfo;
			d.active = true;
			d.prevX = ne.clientX;
			d.prevY = ne.clientY;
			d.pointerId = ne.pointerId;
		}
	}

	onPointerMove(e) {
		const ne = e.nativeEvent;
		const d = this.dragInfo;
		if (ne && d.active) {
			const x = ne.clientX;
			const y = ne.clientY;
			const dx = x - d.prevX;
			const dy = y - d.prevY;

			const dR = dx * 0.03;
			const dT = dy * 0.03;

			const vs = this.skContext.viewState;
			vs.yawAngle += dR;
			this.skContext.wrapAngles();

			vs.pitchAngle += dT;
			const rg = this.pitchRange;
			if (vs.pitchAngle < rg.min) { vs.pitchAngle = rg.min; }
			if (vs.pitchAngle > rg.max) { vs.pitchAngle = rg.max; }

			this.fire();

			d.prevX = x;
			d.prevY = y;
		}
	}

	onPointerUp(_e, _eventOwnerElement) {
		const d = this.dragInfo;
		d.active = false;
	}

	fire() {
		if (this.listener) {
			this.listener.svOnChange?.();
		}
	}
}

export default StekViewController;